import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { useScrollLock } from "../../hooks/useScrollLock";
import { useLocation } from "react-router-dom";
import { showModal } from "../../features/modal/modalSlice";
import PageTopTitle from "../shared/PageTopTitle";
import Button from "../shared/button/Btn";
import { useEffect } from "react";

const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 26;

  .modal {
    width: 1050px;
    max-width: 850px;
    height: auto;
    color: ${({ theme }) => theme.mainTextColor};
    background-color: ${({ theme }) => theme.mainBgColor};
    border: 1px solid;
    border-color: ${({ theme }) => theme.mainBorderColor};
    padding-top: 20px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .content {
      margin-top: 20px;
      padding: 20px;
      width: 600px;
      display: flex;
      flex-direction: column;
      gap: 20px;

      .yeterlilik-item {
        padding: 10px 20px;
        border-radius: 10px;
        background-color: ${({ theme }) => theme.secondaryBgColor};
      }
    }

    .button-grp {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-top: auto;
      margin: 30px 0;
    }
  }
`;

const UyeMeslekiYeterlilikModal = () => {
  const dispatch = useDispatch();

  const location = useLocation();

  const { modalLocation } = useSelector((state) => state.modal);
  const { lockScroll, unlockScroll } = useScrollLock();
  const { uyeMeslekiYeterlilik } = useSelector((state) => state.uyelerAraclar);
  const { uyeItemData } = useSelector((state) => state.admin2);

  //! bu modal açıldığnda ekran ı lock lamak için
  useEffect(() => {
    lockScroll();

    return () => {
      unlockScroll();
    };
  }, [lockScroll, unlockScroll]);

  //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
  useEffect(() => {
    if (location.pathname !== modalLocation) {
      dispatch(showModal(null));
    }
  }, [dispatch, location.pathname, modalLocation]);

  return (
    <ModalContainer onClick={() => dispatch(showModal(null))}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <PageTopTitle title={"Üyenin Mesleki Yeterlilikleri"} />
        <div className="content">
          {uyeMeslekiYeterlilik?.map((item, i) => (
            <div key={i} className="yeterlilik-item">
              {item}
            </div>
          ))}
          {/* {uyeItemData?.srcTypes?.length > 0 ?
            <>
              {uyeItemData?.srcTypes?.map((item) =>(
                <div className="yeterlilik-item">
                  {item?.srcBelgesi}
                </div>
              ))}
            </>
            :
            <div className="yeterlilik-item">
              Kayıtlı bir src belgesi bulunmamaktadır.
            </div>
          } */}
          
          
        </div>
        <div className="button-grp">
          <Button
            color={"#E85546"}
            background={"#FF0000"}
            width="310px"
            radius={"10px"}
            handleClick={() => dispatch(showModal(null))}
          >
            Geri Dön
          </Button>
        </div>
      </div>
    </ModalContainer>
  );
};

export default UyeMeslekiYeterlilikModal;
